export const email = "E-Mail";
export const password = "Wachtwoord";
export const phone = "Telefoon";
export const loadingText = "Laden...";
export const salutation = "Aanhef";
export const insertion = "Tussenvoegsel";
export const first_name = "Voornaam";
export const last_name = "Achternaam";
export const name = "Naam";
export const address = "Adres";
export const street = "Straat";
export const house_number = "Huisnummer";
export const number_addition = "Toevoeging";
export const zipcode = "Postcode";
export const city = "Plaats";
export const country = "Land";
export const date = "Datum";
export const day_preference = "Dag voorkeur";
export const lead_source = "Lead bron";
export const bathroom_type = "Badkamer type";
export const inspiration_book = "Inspiratieboek";
export const accept_terms = "Ik ga akkoord met de algemene voorwaarden";
export const longitude = "Lengtegraad";
export const latitude = "Breedtegraad";
export const build_year = "Bouwjaar";
export const woz_values = "Woz waarden";
export const notes = "Notities";
export const status = "Status";
export const created_at = "Aangemaakt op";
export const updated_at = "Bijgewerkt op";
export const service_status = "Service status";
export const service_request = "Service aanvraag";
export const service_image = "Service afbeelding";
export const required = "Verplicht";
export const notRequired = "Niet verplicht";
export const followUp = "Opvolgen";

export const translateMenu = (word: string) => {
  const foundTranslation: any = {
    dashboard: "Dashboard",
    orders: "Orders",
    products: "Producten",
    users: "Gebruikers",
    instellingen: "Instellingen",
    bedrijfsgegevens: "Bedrijfsgegevens",
    admin: "Prijsbeheer",
    dealers: "Dealers",
    "mijn-dealers": "Mijn Dealers",
    "mijn-rapporten": "Bezoekrapporten",
    marketing: "Marketing Materiaal",
    beeldbank: "Beeldbank",
  };

  return foundTranslation[word];
};

export const translate = (word: string) => {
  const foundTranslation: any = {
    ALL: "Allemaal",

    FLOWPACK: "Flowpack",

    CARTON: "Slofjes",

    PASTRY: "Gebak",

    DOUGH: "Degen",

    CAKE_PUMP: "Cake pompen",

    OTHER: "Overige",
  };

  return foundTranslation[word];
};

export const transalteDays = (day: number) => {
  const foundTranslation: any = {
    0: "Vandaag",
    1: "Morgen",
    2: "Overmorgen",
  };

  return foundTranslation[day];
};

export const translateContract = (word: string) => {
  const foundTranslation: any = {
    PERMANENT: "Vast",
    TEMPORARY: "Tijdelijk",
    PART_TIME: "Parttime",
    FULL_TIME: "Fulltime",
    CALL_BASE: "Oproep",
    ACTIVE: "Actief",
    INACTIVE: "Inactief",
  };

  return foundTranslation[word];
};
